"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CCItemsToJSON = exports.CCItemsToJSONJoined = exports.CCItemsFromJSONTyped = exports.CCItemsFromJSON = exports.instanceOfCCItems = exports.CCItemsTypeEnum = exports.attributeTypeMapCCItems = void 0;
var CCEmail_1 = require("./CCEmail");
var CCRole_1 = require("./CCRole");
exports.attributeTypeMapCCItems = [
    {
        name: "id",
        type: "string",
    },
    {
        name: "type",
        type: "string",
    },
];
/**
 * @export
 */
exports.CCItemsTypeEnum = {
    CcRole: "ccRole",
    CcEmail: "ccEmail",
};
/**
 * Check if a given object implements the CCItems interface.
 */
function instanceOfCCItems(value) {
    if (!("id" in value) || value["id"] === undefined)
        return false;
    if (!("type" in value) || value["type"] === undefined)
        return false;
    return true;
}
exports.instanceOfCCItems = instanceOfCCItems;
function CCItemsFromJSON(json) {
    return CCItemsFromJSONTyped(json, false);
}
exports.CCItemsFromJSON = CCItemsFromJSON;
function CCItemsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json["type"] === "ccEmail") {
            return (0, CCEmail_1.CCEmailFromJSONTyped)(json, true);
        }
        if (json["type"] === "ccRole") {
            return (0, CCRole_1.CCRoleFromJSONTyped)(json, true);
        }
    }
    return {
        id: json["id"],
        type: json["type"],
    };
}
exports.CCItemsFromJSONTyped = CCItemsFromJSONTyped;
function CCItemsToJSONJoined(value) {
    if (value == null) {
        return value;
    }
    if (value["type"] === "ccEmail") {
        return (0, CCEmail_1.CCEmailToJSON)(value);
    }
    if (value["type"] === "ccRole") {
        return (0, CCRole_1.CCRoleToJSON)(value);
    }
}
exports.CCItemsToJSONJoined = CCItemsToJSONJoined;
function CCItemsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value["id"],
        type: value["type"],
    };
}
exports.CCItemsToJSON = CCItemsToJSON;
